import {Injectable, inject} from '@angular/core';
import {environment} from "projects/store/src/environments/environment";
import {Router} from "@angular/router";
import {LocalStorageKey, SalesWorkflow} from "projects/store/src/app/enums";
import {LocalStorageService} from "library";
import {MacroFlowMapping} from "projects/store/src/app/enums";
import {AuthService} from 'projects/store/src/app/services/api/v1/auth.service';
import {MacroFlowService} from 'projects/store/src/app/services/api/v1/macro-flow.service';

@Injectable({
  providedIn: 'root'
})
export class PathNavigationService {

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    private macroFlowService: MacroFlowService
  ) { }

  navigateToInvalidSession(flowCode: string): void {
    this.router.navigate([`/ventas/${flowCode}/error/sesion-invalida`]);
  }

  navigateToPointSaleBlocked(flowCode: string): void {
    this.router.navigate([`/ventas/${flowCode}/error/punto-de-venta-bloqueado`]);
  }

  navigateToRequestNotApproved(flowCode: string, state: any): void {
    this.router.navigate([`/ventas/${flowCode}/error/solicitud-no-aprobada`], {state});
  }

  navigateToRequestNotAvailable(flowCode: string, state: any): void {
    this.router.navigate([`/ventas/${flowCode}/error/solicitud-no-disponible`], {state});
  }

  navigateToInitialGeneral(): void {
    const { routerLink, queryParams } = this.pathToInitialGeneral();
    this.router.navigate([routerLink], { queryParams });
  }

  pathToInitialGeneral(): { routerLink: string; queryParams: { start_token: string } } {
    const webPageStartToken= btoa(JSON.stringify(this.localStorageService.get(LocalStorageKey.startToken)));
    const routerLink = `/ventas/${this.macroFlowService.getGeneralFlow()}`;
    const queryParams = { start_token: `${webPageStartToken}` };
    return { routerLink, queryParams };
  }

  pathToInitialStore(isAuthenticated: boolean): {routerLink: string} {
    let routerLink;
    if(isAuthenticated) {
      routerLink = `/inicio`;
    }else {
      routerLink = `/ventas/${this.macroFlowService.getAutogestionTiendaFlow()}`;
    }
    return {routerLink};
  }

  pathToInitialGestionStore(isAuthenticated: boolean): { routerLink: string; queryParams?: { start_token: string } } {
    let routerLink;
    if(isAuthenticated) {
      routerLink = `/inicio`;
      return {routerLink}
    }else {
      const webPageStartToken= btoa(JSON.stringify(this.localStorageService.get(LocalStorageKey.startToken)));
      const routerLink = `/ventas/${this.macroFlowService.getGeneralTiendaFlow()}`;
      const queryParams = { start_token: `${webPageStartToken}` };
      return { routerLink, queryParams };
    }
  }

  navigateToInitialStore(isAuthenticated: boolean): void {
    this.router.navigate([this.pathToInitialStore(isAuthenticated).routerLink]);
  }

  navigateToInitialGestionStore(isAuthenticated: boolean): void {
    this.router.navigate([this.pathToInitialGestionStore(isAuthenticated).routerLink]);
  }

  pathToInitialKredicashCliente(flowCode: string, categoryCode: string, path: string): {routerLink: string} {
    const routerLink = `/ventas/${flowCode}/categoria/${categoryCode}/${path}`;
    return {routerLink}
  }

  navigateToInitialKredicashCliente(flowCode: string, categoryCode: string, path: string): void {
    this.router.navigate([this.pathToInitialKredicashCliente(flowCode, categoryCode, path).routerLink]);
  }

  pathToInitialKredicashExpress(flowCode: string, categoryCode: string, path: string): {routerLink: string} {
    const routerLink = `/ventas/${flowCode}/categoria/${categoryCode}/${path}`;
    return {routerLink}
  }

  navigateToInitialKredicashExpress(flowCode: string, categoryCode: string, path: string): void {
    this.router.navigate([this.pathToInitialKredicashExpress(flowCode, categoryCode, path).routerLink]);
  }

  navigateToExitAppKrdya() {
    this.router.navigate([], {queryParams: { action: 'exit' }, queryParamsHandling: 'merge'});
  }
  pathToInitialExperanza(isAuthenticated: boolean): { routerLink: string } {
    if (isAuthenticated) {
      return { routerLink: `/inicio` };
    }
    return { routerLink: `/tiendas/ventas/${this.macroFlowService.getGeneralExperanzaFlow()}` };
  }

  navigateToInitialExperanza(isAuthenticated: boolean): void {
    this.router.navigate([this.pathToInitialExperanza(isAuthenticated).routerLink]);
  }

}
